/**
 * 이 사람에게 모니터링(상시 수집 · 실시간 대시보드) 권한이 있는가 — 메뉴를 감출지 정한다(2026-10-03).
 * 판정은 서버가 한다(티어의 'monitoring' 또는 관리자, backend collectionAccess.hasMonitoringFeature).
 * 스탠드얼론은 혼자 쓰는 빌드라 늘 있다. 실패하면 없는 것으로 — 메뉴가 보여도 열면 403 이라 감추는 편이 낫다.
 */
import { useEffect, useState } from 'react';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';

// grade — 사용자 유형(2026-10-29, backend modules/userGrade): beginner 는 모니터링 · DB 전문가 메뉴/기능을 감춘다.
//   서버가 같은 판정으로 API 를 막으므로 감추는 것은 모양일 뿐이다. 모르면 beginner(서버와 같은 fail-closed)
// canPublish — 남에게 보이는 가이드·튜닝 사례를 직접 등록(Expert·관리자)
// ready — 서버 답을 받았는가(받기 전의 NONE 을 「권한 없음」 으로 읽어 값을 바꾸면 안 되는 화면이 본다)
const NONE = { monitoring: false, admin: false, grade: 'beginner', canPublish: false, ready: false };
const ALL = { monitoring: true, admin: true, grade: 'expert', canPublish: true, ready: true };

/** 모니터링 · DB 전문가 메뉴/기능을 쓰는가 */
export const usesExpertMenus = (access) => !!access && access.grade !== 'beginner';

/** @returns {{ monitoring: boolean, admin: boolean, grade: string, canPublish: boolean }} admin — 전역 설정 메뉴(데이터소스·쿼리 템플릿)를 보일지 */
export default function useMonitoringAccess(active, standalone = false) {
    const [can, setCan] = useState(standalone ? ALL : NONE);
    useEffect(() => {
        if (standalone) { setCan(ALL); return undefined; }
        if (!active) { setCan(NONE); return undefined; }
        let alive = true;
        fetch(`${BASE_URL}/me/access`)
            .then(r => (r.ok ? r.json() : null))
            .then(j => {
                if (!alive) return;
                setCan({
                    monitoring: !!(j && j.monitoring), admin: !!(j && j.admin),
                    grade: (j && ['beginner', 'advanced', 'expert'].includes(j.grade)) ? j.grade : 'beginner',
                    canPublish: !!(j && j.canPublish),
                    ready: !!j,
                });
            })
            .catch(() => { if (alive) setCan(NONE); });
        return () => { alive = false; };
    }, [active, standalone]);
    return can;
}
